import React, { useEffect, useState } from "react";
import SlickSlider from "../SlickSlider/SlickSlider";
import WhyChooseUsItem from "./WhyChooseUsItem";
import StatsSection from "../StatsSection/StatsSection";
import { useLanguage } from "../../context/LanguageContext";
import { FaChartLine, FaGlobe, FaBuilding, FaUsers, FaFileInvoice, FaMapMarkerAlt } from "react-icons/fa";

const WhyChooseUs = () => {
  const { t } = useLanguage();

  const slickSettings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const slider_items = [
    {
      icon: <FaChartLine />,
      title: t("whyChooseUs.items.0.title"),
      description: t("whyChooseUs.items.0.description"),
    },
    {
      icon: <FaGlobe />,
      title: t("whyChooseUs.items.1.title"),
      description: t("whyChooseUs.items.1.description"),
    },
    {
      icon: <FaBuilding />,
      title: t("whyChooseUs.items.2.title"),
      description: t("whyChooseUs.items.2.description"),
    },
    {
      icon: <FaUsers />,
      title: t("whyChooseUs.items.3.title"),
      description: t("whyChooseUs.items.3.description"),
    },
    {
      icon: <FaFileInvoice />,
      title: t("whyChooseUs.items.4.title"),
      description: t("whyChooseUs.items.4.description"),
    },
    {
      icon: <FaMapMarkerAlt />,
      title: t("whyChooseUs.items.5.title"),
      description: t("whyChooseUs.items.5.description"),
    },
  ];

  const initalState = 0;
  const [count, setCount] = useState(initalState);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((old) => (old == 6 ? 0 : old + 1));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const toMultiply = 100 / slider_items.length;

  return (
    <section id="why-choose-us" className="choose-area pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-8">
            <div className="section-title text-center mb-50">
              <h2 className="title">
                {t("whyChooseUs.title").split("Dubai").map((part, index, array) => (
                  <React.Fragment key={index}>
                    {part}
                    {index < array.length - 1 && <span className="text-info">Dubai</span>}
                  </React.Fragment>
                ))}
              </h2>
              <p className="description text-light mt-4" style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
                {t("whyChooseUs.description")}
              </p>
            </div>
          </div>
        </div>

        <div className="row choose-active">
          <SlickSlider settings={slickSettings}>
            {slider_items.map((item, index) => (
              <div key={index} className="col-lg-3">
                <WhyChooseUsItem item={item} />
              </div>
            ))}
          </SlickSlider>
        </div>

        <div className="slide-progressbar">
          <div
            style={{
              // width: `${count * toMultiply}%`,
              backgroundSize: `${count * toMultiply}% 100%`,
            }}
            className="slide-filler"
          />
        </div>

        {/* <div
          className="slide-progress"
          role="progressbar"
          aria-valuemin="0"
          aria-valuemax="100"
        >
          <span className="slider__label sr-only"></span>
        </div> */}
      </div>
      
      {/* Stats Section */}
      <StatsSection />
    </section>
  );
};

export default WhyChooseUs;
